import calculateMenuItemPrice from "../../../../utils/calculateMenuItemPrice";
import { pluralize } from "../../../../utils/pluralize";
import ImageLoader from "../../../../components/imageLoader";
import { useMemo } from "react";

const MenuItemCard = ({
  product,
  restaurant,
  activeCategory,
  categories,
  onPress,
}) => {
  const isDisabled = useMemo(
    () =>
      product.status !== "active" ||
      !restaurant.isWorking ||
      activeCategory.status !== "active",
    [activeCategory, product, restaurant],
  );

  const category = useMemo(
    () => categories.find((category) => category.id === product.category_id),
    [product, categories],
  );

  const productName = useMemo(() => {
    const array = [product.name];

    if (!category?.has_one_size) {
      array.push(product.size.name);
    }

    return array.join(" - ");
  }, [product, category]);

  const requireds = useMemo(() => {
    const { size } = product;
    const items = [];

    product.requireds.forEach((required) => {
      const { chooses } = required;

      const choose = chooses.find((choose) => choose.size_id === size.id);

      if (product.size.pieces > 0) {
        items.push(pluralize("pedaço", product.size.pieces));
      }

      if (choose?.show_to_users) {
        items.push(`até ${pluralize("sabor", choose.numChoose)}`);
      }
    });

    return items.join(" - ");
  }, [product]);

  const handlePress = () => {
    if (isDisabled) return;

    onPress();
  };

  return (
    <div
      onClick={handlePress}
      className={[
        "shadow flex flex-col border border-gray-100 transition-all rounded-lg overflow-hidden",
        isDisabled
          ? "cursor-not-allowed opacity-50"
          : "cursor-pointer hover:border-primary-300",
      ].join(" ")}
    >
      <div className="h-48 overflow-hidden">
        <ImageLoader
          alt={product.name}
          src={
            product.photo
              ? `${process.env.REACT_APP_SERVER_BETABIT_BASE_API}/files/products/${product.photo}`
              : undefined
          }
        />
      </div>
      <div className="p-6">
        <h3 className="text-lg font-extrabold text-black line-clamp-2 mb-2">
          {productName}
        </h3>

        <p className="h-10 text-gray-600 grow text-xs mb-4 leading-relaxed line-clamp-2 m-0">
          {product.description || "Sem descrição disponível"}
        </p>

        {requireds && (
          <div className="text-sm text-gray-500 mb-2">{requireds}</div>
        )}

        <span className="text-primary-500 font-black text-2xl">
          {calculateMenuItemPrice(product)}
        </span>
      </div>
    </div>
  );
};

export default MenuItemCard;
